import React, { forwardRef, useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { BaseButton } from '../button';
import { useMenuContext } from './menu-context';
import styles from './styles.module.css';
/**
 * `<MenuButton />` — Дублирует функционал `<BaseButton />` с доработками для работы с `<Menu />`,
 * а также необходимыми свойствами для обеспечения доступности.
 * @param {MenuButtonProps} props
 * @constructor
 */
export const MenuButton = /*#__PURE__*/forwardRef(({
  onClick,
  wide,
  ...props
}, ref) => {
  const {
    buttonRef,
    action,
    isMenuOpen
  } = useMenuContext();
  const clickHandler = useCallback(event => {
    action == null ? void 0 : action(event);
    onClick == null ? void 0 : onClick(event);
  }, [onClick, action]);
  const wrapperClassName = useMemo(() => clsx(styles.buttonWrapper, {
    [styles.wideButton]: wide
  }), [wide]);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    ref: buttonRef
  }, /*#__PURE__*/React.createElement(BaseButton, {
    onClick: clickHandler,
    "aria-haspopup": "listbox",
    "aria-expanded": isMenuOpen,
    "data-menu-item": true,
    tabIndex: isMenuOpen ? -1 : 0,
    ref: ref,
    ...props
  }));
});